import { render, staticRenderFns } from "./new-schools.vue?vue&type=template&id=bd98cea6&scoped=true&"
import script from "./new-schools.vue?vue&type=script&lang=js&"
export * from "./new-schools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd98cea6",
  null
  
)

export default component.exports